const STORAGE_KEY = 'saay-admin-web-prefs';

type TargetingAudienceType = 'GEOGRAPHY' | 'INDIVIDUAL' | 'ORGANIZATION' | 'ORGANIZATION_ROLE';

type Prefs = {
  readonly approvalsView?: 'all' | 'decidable' | 'requested';
  readonly buyersTableColumns?: readonly string[];
  readonly targetingAudienceType?: TargetingAudienceType;
};

const BUYERS_TABLE_COLUMNS_DEFAULT = ['buyer', 'nationalCode', 'available', 'status'] as const;

/** Default visible buyer-list columns (ADM-37). */
export function defaultBuyersTableColumns(): readonly string[] {
  return BUYERS_TABLE_COLUMNS_DEFAULT;
}

export function readBuyersTableColumns(): readonly string[] {
  const stored = read().buyersTableColumns;
  if (stored === undefined || stored.length === 0) {
    return defaultBuyersTableColumns();
  }
  return stored;
}

export function storeBuyersTableColumns(columnIds: readonly string[]): void {
  const current = read();
  write({ ...current, buyersTableColumns: [...columnIds] });
}

function read(): Prefs {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (raw === null || raw === '') {
      return {};
    }
    const parsed = JSON.parse(raw) as Prefs;
    return typeof parsed === 'object' && parsed !== null ? parsed : {};
  } catch {
    return {};
  }
}

function write(next: Prefs): void {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}

/** Non-sensitive UI choice (FND-25): the approval inbox view filter. */
export function readApprovalsView(): Prefs['approvalsView'] {
  return read().approvalsView;
}

export function storeApprovalsView(view: Prefs['approvalsView']): void {
  const current = read();
  write(view === undefined ? current : { ...current, approvalsView: view });
}

/** Last targeting audience segment (ADM-56, FND-25). */
export function readTargetingAudienceType(): TargetingAudienceType | undefined {
  return read().targetingAudienceType;
}

export function storeTargetingAudienceType(type: TargetingAudienceType): void {
  const current = read();
  write({ ...current, targetingAudienceType: type });
}
